<template>
  <PageContainer type="bg2">
    <div class="order">
      <div class="search-bar">
        <el-select
          v-model="search.status"
          placeholder="請選擇訂單狀態"
          clearable
          @change="handleChangeSelect"
        >
          <el-option
            v-for="item in statusOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-button icon="el-icon-refresh-right" circle style="margin-left: 16px" @click="handleReload" />
      </div>

      <el-table
        :data="tableList"
        align="center"
        empty-text="暫無資料"
      >
        <el-table-column
          label="訂單管理"
          min-width="120"
        >
          <template slot-scope="{row}">
            <el-button v-if="row.status === 'WAIT_BUYER_PAY' && row.paymentType !== 'CASH'" type="primary" @click="payOrder(row)">付款</el-button>
            <el-button v-if="row.status === 'ALREADY_SEND'" type="primary" @click="checkOrderArrivals(row)">確認收貨</el-button>
          </template>
        </el-table-column>
        <el-table-column
          prop="paymentType"
          label="付款方式"
          min-width="120"
        >
          <template slot-scope="{row}">
            <p v-if="row.paymentType !== 'CASH'">{{ `${PaymentTypeMap[row.paymentType]}` }}</p>
            <el-button v-if="row.paymentType === 'CASH'" type="text" style="padding: 0" @click="handleOpenCashRuleModal()">{{ `${PaymentTypeMap[row.paymentType]}(查看規則)` }}</el-button>
          </template>
        </el-table-column>
        <el-table-column
          prop="orderNo"
          label="編號"
          min-width="190"
        />
        <el-table-column
          label="訂單狀態"
          min-width="100"
        >
          <template slot-scope="{row}">
            <el-tag :type="`${StatusTagMap[row.status]}`">{{ StatusMap[row.status] }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          min-width="100"
          label="訂單明細"
        >
          <template slot-scope="{row}">
            <el-button type="text" style="padding: 0" @click="handleOpenOrderDetailModal(row.orderItemSet)">查看</el-button>
          </template>
        </el-table-column>
        <el-table-column
          prop="note"
          label="備註"
          min-width="100"
        >
        </el-table-column>
        <el-table-column
          prop="paySuccessTime"
          label="付款時間"
          min-width="100"
        >
        </el-table-column>
        <el-table-column
          min-width="100"
          label="訂單總額"
        >
          <template slot-scope="{row}">
            {{ row.totalPrice | currency }}
          </template>
        </el-table-column>
        <el-table-column
          min-width="100"
          label="訂單實際總額"
        >
          <template slot-scope="{row}">
            {{ row.realTotalPrice | currency }}
          </template>
        </el-table-column>
        <el-table-column
          min-width="100"
          label="訂單總購物回潤金"
        >
          <template slot-scope="{row}">
            {{ row.totalReturnMoney | currency }}
          </template>
        </el-table-column>
        <el-table-column
          label="訂貨人資訊"
          min-width="200"
        >
          <template slot-scope="{row}">
            <p>{{ row.user.name }}</p>
            <p v-if="row.receiveType === 'HOME_DELIVERY'">
              {{ `${row.province}${row.city}${row.district}${row.address}` }}
            </p>
            <p v-if="row.receiveType === 'HOME_OTHER_DELIVERY'">
              {{ `${row.address}` }}
            </p>
          </template>
        </el-table-column>
        <el-table-column
          prop="receiverTel"
          label="訂貨人電話"
          min-width="100"
        />
        <el-table-column
          prop="receiveType"
          label="取貨方式"
          min-width="100"
        >
          <template slot-scope="{row}">
            {{ `${ReceiveTypeMap[row.receiveType]}` }}
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        layout="prev, pager, next"
        :page-size="page.size"
        :total="page.total"
        :current-page="page.current"
        @current-change="handleChange"
      />
      <div v-html="payForm" />
      <el-dialog
        title="訂單明細"
        :visible.sync="orderDetailModalVisible"
        :width="dialogWidth"
        :before-close="handleCloseOrderDetailModal"
      >
        <el-row v-for="({item, num, price, returnMoney},index) in orderDetail" :key="index">
          <el-col :xs="24" :md="12">
            <img :src="item.imageUrl">
          </el-col>
          <el-col :xs="24" :md="12">
            名稱： {{ item.title }} <br>
            價格： {{ price }} <br>
            購物回潤金： {{ returnMoney }} <br>
            數量： {{ num }} <br>
          </el-col>
        </el-row>
      </el-dialog>
      <el-dialog
        title="現金規則"
        :visible.sync="cashRuleModalVisible"
        :width="dialogWidth"
        :before-close="handleCloseCashRuleModal"
      >
        <p>親愛的:{{ userName }}</p>
        <p>感謝您此次購買</p>
        <p>為使交易流程更加順暢</p>
        <p>要請您儘速利用ATM轉帳或銀行匯款至如下帳戶：</p>
        <p>銀行：國泰世華(013)</p>
        <p>分行：昌平分行</p>
        <p>帳戶：有限責任希望聯盟消費合作社</p>
        <p>帳戶：236-03-501061-4</p>
        <p>並註明匯款附言內容，並將匯款存根拍照或將末五碼上傳生活圈，註明購物單號；我們將儘速為您處理出貨事宜！！</p>
        <p>溫馨提醒：如訂單超過24小時未完成轉帳匯款，將取消此次訂單申請，謝謝您的支持！！</p>
      </el-dialog>
    </div>
  </PageContainer>
</template>

<script>
import PageContainer from '@/components/PageContainer'
import api from '@/api'
import { mapGetters } from 'vuex'

const StatusMap = {
  WAIT_BUYER_PAY: '等待付款',
  WAIT_SEND_GOODS: '等待寄貨',
  ALREADY_SEND: '已寄出',
  // TRADE_CLOSED: '訂單取消',
  REFUNDED_CLOSED: '訂單已退款',
  TRADE_FINISHED: '訂單完成'
}

const StatusTagMap = {
  WAIT_BUYER_PAY: '',
  WAIT_SEND_GOODS: 'warning',
  ALREADY_SEND: 'info',
  TRADE_CLOSED: 'danger',
  REFUNDED_CLOSED: 'danger',
  TRADE_FINISHED: 'success'
}

const ReceiveTypeMap = {
  TRADE_IN_PERSON: '面交',
  HOME_DELIVERY: '宅配',
  HOME_OTHER_DELIVERY: '宅配-自選地址'
}

const PaymentTypeMap = {
  CREDIT_CARD: '信用卡',
  UNION_PAY: '中國銀聯',
  CASH: '現金'
}

export default {
  components: {
    PageContainer
  },
  data() {
    return {
      StatusMap,
      StatusTagMap,
      ReceiveTypeMap,
      PaymentTypeMap,
      tableList: [],
      page: {
        current: 1,
        total: 0,
        size: 10
      },
      search: {
        status: null
      },
      payForm: ``,
      orderDetailModalVisible: false,
      cashRuleModalVisible: false,
      orderDetail: {}
    }
  },
  computed: {
    ...mapGetters(['isMobile', 'userInfo']),
    userName() {
      return this.userInfo.profile.name
    },
    statusOptions() {
      return Object.keys(this.StatusMap).map(key => ({
        label: this.StatusMap[key],
        value: key
      }))
    },
    dialogWidth() {
      return this.isMobile ? '90%' : '50%'
    }
  },
  created() {
    this.getOrder()
  },
  methods: {
    async getOrder() {
      const params = {
        page: this.page.current,
        size: this.page.size
      }
      this.search.status && (params.status = this.search.status)
      const { data, success } = await api.order.orders(params) || {}
      if (success) {
        this.tableList = data.records
        this.page.total = data.total
      }
    },
    async payOrder({ id: orderId }) {
      const { data, success } = await api.order.payOrder({
        orderId
      })
      if (success) {
        window.location.href = `${data.form}`
      }
    },
    async checkOrderArrivals({ id: orderId }) {
      const { success } = await api.order.checkOrderArrivals({
        orderId
      })
      if (success) {
        this.getOrder()
      }
    },
    handleChange(current) {
      this.page.current = current
      this.getOrder()
    },
    handleChangeSelect() {
      this.page.current = 1
      this.getOrder()
    },
    handleReload() {
      this.page.current = 1
      this.search.status = null
      this.getOrder()
    },
    handleOpenOrderDetailModal(orderItemSet) {
      this.orderDetailModalVisible = true
      this.orderDetail = { ...orderItemSet }
    },
    handleCloseOrderDetailModal() {
      this.orderDetailModalVisible = false
      this.orderDetail = {}
    },
    handleOpenCashRuleModal() {
      this.cashRuleModalVisible = true
    },
    handleCloseCashRuleModal() {
      this.cashRuleModalVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.order {
  width: 100%;
}
::v-deep.el-table {
  margin-top: 20px;
  padding: 0 10px;
  background-color: transparent;
  th, tr {
    background-color: transparent;
  }
  th.is-leaf {
    border-bottom: 1px solid $mainPurple;
  }
}
::v-deep.el-table--enable-row-hover .el-table__body tr:hover>td {
  background-color: #8b2a8920;
}

::v-deep.el-pagination {
    margin-top: 10px;
    text-align: right;
    margin: 10px auto;
    width: 100%;
  }

::v-deep.el-pager li, ::v-deep.el-pagination button:disabled, ::v-deep.el-pagination .btn-next, ::v-deep.el-pagination .btn-prev {
  background-color: transparent;
}
::v-deep.el-pager li.active, ::v-deep.el-pager li:hover {
  color: $mainPurple;
}
::v-deep.el-input__inner {
  border-radius: 20px;
  border-color: $mainPurple;
  color: $mainPurple;
  &:hover, &:focus {
    opacity: 0.8;
    border-color: $mainPurple;
  }
  &::placeholder {
    color: $mainPurple;
  }
}
::v-deep.el-select .el-input.is-focus .el-input__inner {
  border-color: $mainPurple;
  opacity: 0.8;
}
::v-deep.el-select .el-input .el-select__caret {
  color: $mainPurple;
}
::v-deep.el-button--primary {
  background-color: $mainPurple;
  border: 0;
  &:hover, &:focus {
    background-color: $mainPurple;
    opacity: 0.8;
  }
}
::v-deep.el-button--default {
  background: transparent;
  border-color: $mainPurple;
  color: $mainPurple;
  &:hover, &:focus {
    background-color: transparent;
    opacity: 0.6;
  }
}
</style>
